<template>
  <v-container class="pa-4" max-width="600px">
    <v-card>
      <v-card-title>Workflow Test</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="6">
            <v-select
              label="Workflow Template ID"
              v-model="form.workflow_template_id"
              :items="workflow_options_with_empty"
              item-text="name"
              item-value="id"
            />
          </v-col>
           <v-col cols="6">
             <!-- <v-text-field
                label="Company ID"
                v-model.number="form.company_id"
                type="number"
              /> -->
              <SelectorEmpresa
                name="SelectorEmpresa"
                :value="form.company_id"
                :items="company_options"
                :return_obj="false"
                :readonly="false"
                :item_val="'id'" 
                @gotInput="company_updated"
              ></SelectorEmpresa>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-text-field
              label="Name"
              v-model="form.name"
            />
          </v-col>
           <v-col cols="6">
            <v-text-field
              label="Description"
              v-model="form.description"
            />
          </v-col>
        </v-row>

        <v-textarea
            label="Input (JSON)"
            v-model="jsonInput"
            auto-grow
            @blur="parseJsonInput"
            :error-messages="jsonError ? [jsonError] : []"
        />

        <WackScriptEditor
          v-model="form.assert_script"
        />
        <p class="text-caption">
          <i>payload es el context en acabar el workflow. Retorna una llista d'errors (buida si passa): output = [] o output = ['error1', 'error2']</i>
        </p>
        

        <!-- Read-only fields -->
        <v-text-field
          label="Last Run"
          :value="form.last_run"
          readonly
        />
        
        <div class="d-flex align-center mt-4">
        <v-icon v-if="form.passed" color="green" class="mr-2">mdi-check-circle</v-icon>

        <v-chip v-else-if="form.errors" color="red" dark class="mr-2">
            {{ form.errors.length }} error{{ form.errors.length === 1 ? '' : 's' }}
        </v-chip>

        <span>{{ form.passed ? 'Passed' : 'Failed' }}</span>
        </div>

        <!-- Optional: List errors -->
        <v-list
          v-if="!form.passed && form.errors && form.errors.length"
          dense
          class="pa-0"
        >
          <v-sheet max-height="200" class="overflow-y-auto">
            <v-list-item
              v-for="(error, index) in form.errors"
              :key="index"
              class="py-1"
            >
              <v-list-item-content>
                <v-list-item-title
                  class="text-caption red--text"
                  style="white-space: normal; word-break: break-word;"
                >
                  {{ error }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-sheet>
        </v-list>

        <!-- Output Actions -->
        <div v-if="form.output" class="mt-4">
          <v-btn
            color="secondary"
            outlined
            @click.stop="copyOutput"
            class="mr-2"
          >
            <v-icon left>mdi-content-copy</v-icon>
            Copy Output JSON (va a ratos)
          </v-btn>
          <v-btn
            color="primary"
            outlined
            @click.stop="downloadOutput"
          >
            <v-icon left>mdi-download</v-icon>
            Download Output JSON
          </v-btn>
        </div>

      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" @click="submit" :loading="loading" :disabled="loading || !canSave">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import SelectorEmpresa from '@/components/SelectorEmpresa.vue';
import WackScriptEditor from "@/modules/document/infra/WackScriptEditor";

export default {
  name: 'WorkflowTestEditor',
  components: {
    SelectorEmpresa,
    WackScriptEditor
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        workflow_template_id: 0,
        company_id: 0,
        assert_script: '',
        input: {},
        id: null,
        name: '',
        description: '',
        state: '',
        last_run: '',
        passed: null,
        errors: [],
        output: null
      })
    },
    loading: {
      type: Boolean,
      default: false
    },
    workflow_options: {
      type: Array,
      default: () => []
    },
    company_options: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      form: { ...this.value },
      jsonInput: JSON.stringify(this.value.input, null, 2),
      jsonError: null
    };
  },
  computed: {
    workflow_options_with_empty() {
      return [{ id: 0, name: 'Select Workflow Template' }, ...this.workflow_options];
    },
    canSave() {
      return this.form.workflow_template_id && this.form.workflow_template_id !== 0 &&
             this.form.company_id && this.form.company_id !== 0;
    }
  },
  methods: {
    parseJsonInput() {
      try {
        this.form.input = JSON.parse(this.jsonInput);
        this.jsonError = null;
      } catch (err) {
        this.jsonError = 'Invalid JSON';
      }
    },
    submit() {
      this.parseJsonInput();
      if (!this.jsonError) {
        this.$emit('input', this.form);
        this.$emit('submit', this.form);
      }
    },
    company_updated(value) {
      console.log('Company updated:', value);
      this.form.company_id = value
    },
    copyOutput() {
      if (this.form.output) {
        this.$emit('copy-output', this.form.output);
      }
    },
    downloadOutput() {
      if (this.form.output) {
        this.$emit('download-output', this.form.output);
      }
    }
  }
};
</script>
